import { Container, Grid, Box, Skeleton } from '@mui/material';
import React, { FC } from 'react';

const UltimateTestRideSectionSkeleton: FC<any> = () => {
  return (
      <Box py={{ lg: 18, md: 14, sm: 10 }}>
        <Skeleton variant="text" height={90} width="50%" />
         <Skeleton variant="rectangular" height={100} width="70%" />
         <Skeleton variant="text" height={90} width="200px" />
         <Box sx={{ height: { lg: 680, md: 670, sm: 275 } }}>
           <Skeleton variant="rectangular" height="100%" width="100%" />
         </Box>
      </Box>
  );
};

export { UltimateTestRideSectionSkeleton };
